import React from "react";

const FormModalShell = ({
  title,
  apiError,
  onClose,
  columns = 2,
  children
}) => (
  <div
    className={`lightbox small-modal-con courier-form courier-form-${columns}`}
  >
    <div className="lightbox-con">
      <a
        href=""
        className="lightbox-close icon-clear"
        onClick={e => {
          e.preventDefault();
          onClose();
        }}
      />
      {title && <h3 className="courier-form-title">{title}</h3>}
      {apiError && (
        <div className="courier-api-error" role="alert">
          {apiError}
        </div>
      )}
      {children}
    </div>
  </div>
);

export default FormModalShell;
